import { Modal } from 'almanac-ui/Modal'
import { BrandWizardNewDesignModalProps } from './Types'
import Styles from './BrandWizardNewDesignModal.module.scss'
import { ContentTypeCardSwitch } from 'screens/blaze/Home/components/Catalogue/components/ContentTypeCard/ContentTypeCardSwitch'
import { Carousel } from 'components/Carousel/Carousel'
import { AspectRatioKey } from 'components/NewFileModal/Types'
import { VISUAL_GROUPS } from './constants'
import { Search } from './Search'
import { GoToBrandsButton } from './GoToBrandsButton'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const BrandWizardNewDesignModal = ({ brandVisualKit }: BrandWizardNewDesignModalProps) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <Modal.Root size="sm" blaze bodyClassName={Styles.modal}>
      <Modal.Header
        className={Styles.header}
        title="Put your brand kit to work"
        actions={!isMobile && <GoToBrandsButton workspaceId={brandVisualKit.workspace_id} />}
      />
      <div className={Styles.searchContainer}>
        <img
          src="https://res.cloudinary.com/almanac/image/upload/c_scale,w_41/v1722952135/blaze_assets/hd_icons/brand_ruojtv.png"
          alt="Brand"
        />
        <div className={Styles.searchWrapper}>
          <Search initialValues={{ brand_visual_kit_id: brandVisualKit.id }} groups={VISUAL_GROUPS} />
        </div>
      </div>
      <div className={Styles.carouselContainer}>
        <Carousel buttonSize="xs">
          {VISUAL_GROUPS.flatMap((group) => {
            return group.channels.map((channel) => {
              return (
                <ContentTypeCardSwitch
                  key={channel}
                  channel={channel as AspectRatioKey}
                  initialValues={{ brand_visual_kit_id: brandVisualKit.id }}
                />
              )
            })
          })}
        </Carousel>
      </div>

      {isMobile && (
        <Modal.Footer>
          <Modal.FooterContent slot="right">
            <GoToBrandsButton workspaceId={brandVisualKit.workspace_id} />
          </Modal.FooterContent>
        </Modal.Footer>
      )}
    </Modal.Root>
  )
}

export { BrandWizardNewDesignModal }
